import { Link } from 'react-router-dom';
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import WbSunnyOutlinedIcon from "@mui/icons-material/WbSunnyOutlined";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import SearchResults from '../../searchResults/SearchResults'; 
import useClickOutside from '../hooks/useClickOutside';
import { useState } from 'react';

const NavbarLeft = ({ darkMode, toggleDarkMode }) => {
    const [isSearchOpen, setIsSearchOpen] = useState(false);

    const searchRef = useClickOutside(() => {
        setIsSearchOpen(false);
    });

    return (
        <div className="left">
            <Link to="/" style={{ textDecoration: "none" }}>
                <span>
                    nexiasocial
                </span>
            </Link>

            <HomeOutlinedIcon />

            {darkMode ? (
                <DarkModeOutlinedIcon onClick={toggleDarkMode} style={{ cursor: 'pointer' }} />
            ) : (
                <WbSunnyOutlinedIcon onClick={toggleDarkMode} style={{ cursor: 'pointer' }} />
            )}

            <GridViewOutlinedIcon />

            <div ref={searchRef} className="search-container-mobile">
                <SearchOutlinedIcon 
                    className="mobile-search-icon" 
                    onClick={() => setIsSearchOpen(!isSearchOpen)} 
                />
                
                <div className={`search-wrapper ${isSearchOpen ? 'open' : ''}`}>
                    <SearchResults />
                </div>
            </div>
        </div>
    );
};
export default NavbarLeft;